module.exports = __webpack_public_path__ + "static/media/image-bg-preview-chat-mo.5e5f1815.png";